/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {createSlice} from '@reduxjs/toolkit'

const notificationSlice = createSlice({
  name: 'notification',
  initialState: {},
  reducers: {
    setNotification: (state, action) => {
      return action.payload
    },
    clearNotification: () => ({}),
  },
})

export const {setNotification, clearNotification} = notificationSlice.actions

export default notificationSlice.reducer
